import script from "./Inoculant.vue?vue&type=script&setup=true&lang=js"
export * from "./Inoculant.vue?vue&type=script&setup=true&lang=js"

import "./Inoculant.vue?vue&type=style&index=0&id=2a2f7826&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2f7826"]])

export default __exports__